/* Nest: restrict cart shipping estimator to GCC countries, default Kuwait.
   Scope: selects with id starting with "ShippingCalculatorCountry" (cart page + cart drawer).
   Safe-by-default: if no allowed options are found (e.g. translated names we don't know), it leaves the select untouched. */
(function () {
  var ALLOWED = [
    'Kuwait', 'Saudi Arabia', 'United Arab Emirates', 'Qatar', 'Bahrain', 'Oman',
    'الكويت', 'السعودية', 'المملكة العربية السعودية', 'الإمارات', 'الإمارات العربية المتحدة', 'قطر', 'البحرين', 'عمان', 'عُمان', 'سلطنة عمان'
  ];
  var KUWAIT = ['Kuwait', 'الكويت'];

  function norm(v) {
    return (v || '').trim();
  }

  function isMatch(list, opt) {
    return list.indexOf(norm(opt.value)) > -1 || list.indexOf(norm(opt.textContent)) > -1;
  }

  function filterSelect(select) {
    if (!select || select.dataset.nestGccDone === '1') return;
    var options = Array.prototype.slice.call(select.querySelectorAll('option'));
    if (!options.length) return;

    var allowedOpts = options.filter(function (opt) { return isMatch(ALLOWED, opt); });
    if (!allowedOpts.length) return; /* unknown naming: do nothing rather than empty the list */

    options.forEach(function (opt) {
      if (allowedOpts.indexOf(opt) === -1) opt.remove();
    });
    select.dataset.nestGccDone = '1';

    var current = select.selectedOptions && select.selectedOptions[0];
    var currentOk = current && isMatch(ALLOWED, current);
    if (!currentOk) {
      var kw = allowedOpts.filter(function (opt) { return isMatch(KUWAIT, opt); })[0] || allowedOpts[0];
      if (kw) {
        select.value = kw.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function scan() {
    var selects = document.querySelectorAll('select[id^="ShippingCalculatorCountry"]');
    Array.prototype.forEach.call(selects, filterSelect);
  }

  function init() {
    scan();
    if (!document.body) return;
    var observer = new MutationObserver(function () { scan(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
